var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 60,
    viewBox: "0 0 49 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 29.5,
    r: 21.5,
    stroke: "#4EDC37",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7025 29.6109C15.3094 29.2229 14.6763 29.227 14.2883 29.6201C13.9003 30.0131 13.9044 30.6463 14.2975 31.0343L15.7025 29.6109ZM22.7778 38L22.0753 38.7117C22.2833 38.917 22.5707 39.0211 22.862 38.9965C23.1532 38.9718 23.4191 38.8211 23.5897 38.5837L22.7778 38ZM35.8119 21.5837C36.1343 21.1353 36.0322 20.5105 35.5837 20.1881C35.1353 19.8657 34.5105 19.9678 34.1881 20.4163L35.8119 21.5837ZM14.2975 31.0343L22.0753 38.7117L23.4803 37.2883L15.7025 29.6109L14.2975 31.0343ZM23.5897 38.5837L35.8119 21.5837L34.1881 20.4163L21.9658 37.4163L23.5897 38.5837Z",
    fill: "#4EDC37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.8dc66858c005608b505beb933c138485.svg";
export { ForwardRef as ReactComponent };